import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import type { ResourceContactType } from "shared/types/outreach";

import type ContactList from "./ContactList";
import type ContactMailingList from "./ContactMailingList";
import type MediaRelease from "./MediaRelease";

@Model()
class MediaReleaseRecipient extends ApplicationRecord {
  static jsonapiType = "media_release_recipients";

  @BelongsTo() contact: ResourceContactType;

  @Attr() contactId: number;

  @BelongsTo() contactList: ContactList;

  @Attr() contactListId: number;

  @BelongsTo() contactMailingList: ContactMailingList;

  @Attr() contactMailingListId: number;

  @Attr() contactType: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) email: string;

  @BelongsTo() mediaRelease: MediaRelease;

  @Attr() mediaReleaseId: number;

  @Attr() message: string;

  @Attr({ persist: false }) name: string;

  @Attr({ persist: false }) personalised: boolean;

  @Attr() subject: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default MediaReleaseRecipient;
